var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvirenmentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "40px",
    viewBox: "0 0 32 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Empty-dashboard-Choice-",
    transform: "translate(-704.000000, -373.000000)",
    fill: "#057EB6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modal",
    transform: "translate(221.000000, 223.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(360.000000, 119.999970)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(122.999969, 30.000024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0785959,25.0957584 C25.6567397,30.3943782 21.2099195,34.5771256 15.8046802,34.5771256 C10.399441,34.5771256 5.95270333,30.3943782 5.5308471,25.0957584 L26.0785959,25.0957584 Z M23.1682583,0 C23.6240314,0 23.9934857,0.369454292 23.9934857,0.825227366 C23.9934857,1.28100044 23.6240314,1.65045473 23.1682583,1.65045473 L23.1682583,1.65045473 L11.607318,1.65045473 L11.607318,10.2082276 C11.607318,10.5584541 11.3863221,10.8704725 11.0559836,10.9867471 C5.43024363,12.9659724 1.65045473,18.3042857 1.65045473,24.2705145 C1.65045473,32.0337584 7.96633237,38.3495535 15.7294938,38.3495535 C23.4927377,38.3495535 29.8085328,32.0337584 29.8085328,24.2705145 C29.8085328,18.3042857 26.0288264,12.9659724 20.4030864,10.9867471 C20.0727479,10.8704725 19.851752,10.5584541 19.851752,10.2082276 L19.851752,10.2082276 L19.851752,4.86372505 C19.851752,4.40795197 20.2212063,4.03849768 20.6769794,4.03849768 C21.1327525,4.03849768 21.5022068,4.40795197 21.5022068,4.86372505 L21.5022068,4.86372505 L21.5022068,9.63543724 C27.4817217,11.9940196 31.4589875,17.8020523 31.4589875,24.2705145 C31.4589875,32.9438191 24.4027984,40 15.7294938,40 C7.05627164,40 0,32.9438191 0,24.2705145 C0,17.8020523 3.97734833,11.9940196 9.9568633,9.63543724 L9.9568633,9.63543724 L9.9568633,1.65045473 L8.29081177,1.65045473 C7.8350387,1.65045473 7.46558441,1.28100044 7.46558441,0.825227366 C7.46558441,0.369454292 7.8350387,0 8.29081177,0 L8.29081177,0 Z M26.9365023,23.4453036 C27.3922753,23.4453036 27.7617296,23.8147579 27.7617296,24.270531 C27.7617296,30.863685 22.3978343,36.2275804 15.8046802,36.2275804 C9.2115262,36.2275804 3.84763084,30.863685 3.84763084,24.270531 C3.84763084,23.8147579 4.21708514,23.4453036 4.67285821,23.4453036 L4.67285821,23.4453036 Z",
    id: "Fill-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvirenmentIcon);
export default __webpack_public_path__ + "static/media/envirenment_icon.a0b396d6667df4bf362258ddc054c58e.svg";
export { ForwardRef as ReactComponent };